<template>
  <v-container fluid class="fixedasset-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-fixedasset`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-shape</v-icon>
            Asset
          </v-tab>
          <v-tab-item
            :value="'tab-fixedasset'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Asset</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'assetcode')"
                        v-bind:value="initvalue.assetcode"
                        placeholder="Asset Code"
                        persistent-hint
                        single-line hint="Enter the asset code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'assetname')"
                        v-bind:value="initvalue.assetname"
                        placeholder="Asset Name"
                        persistent-hint
                        single-line hint="Enter the asset name">
                      </v-text-field>
                      <v-select
                          class="mb-4"
                          :items=assettypes
                          v-on:change="updateChangedValue($event, 'assettype')"
                          v-bind:value="initvalue.assettype"
                          outlined
                          dense
                          placeholder="Asset Type"
                          persistent-hint
                          single-line hint="Please choose the asset type">
                        </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                          class="mb-4"
                          :items=deptypes
                          v-on:change="updateChangedValue($event, 'deptype')"
                          v-bind:value="initvalue.deptype"
                          outlined
                          dense
                          placeholder="Depreciation Type"
                          persistent-hint
                          single-line hint="Please choose the depreciation type">
                        </v-select>
                      <v-text-field
                          type="number"
                          class="mb-4"
                          v-on:change="updateChangedValue($event, 'depyears')"
                          v-bind:value="initvalue.depyears"
                          outlined
                          dense
                          placeholder="Depreciation Years"
                          persistent-hint
                          single-line hint="Enter the depreciation years">
                        </v-text-field>
                        <v-text-field
                          type="number"
                          class="mb-4"
                          v-on:change="updateChangedValue($event, 'deprate')"
                          v-bind:value="initvalue.deprate"
                          outlined
                          dense
                          placeholder="Depreciation Rate"
                          persistent-hint
                          single-line hint="Enter the depreciation rate">
                        </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/fixedasset/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editFixedAsset()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      edit_asset: {},
      initvalue: {},
      deptypes: ['Straight Line', 'Declining Balance'],
      assettypes: ['Land', 'Building', 'Factory', 'Equipment & Machinery', 'Furniture & Fixture', 'Computer & Software', 'Vehicle'],
    }
  },
  methods: {
    ...mapActions('FixedAsset', ['updateFixedAssetRequest','getFixedAssetsRequest']),
    editFixedAsset() {
      this.edit_asset._id = this.initvalue._id;
      this.updateFixedAssetRequest(this.edit_asset);
      this.getFixedAssetsRequest();
      router.push('/fixedasset/list');
    },
    updateChangedValue(value, field){
      this.edit_asset[field] = value;
    },
  },
  computed: {
    ...mapState('FixedAsset', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'FixedAssetList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
